export default "__VITE_ASSET__DOGx3rfv__"